import trackerClient from './client'
import { TrackerActionPayload, TrackerBootstrapResponse, TrackerSession, TrackerStartLocationPayload } from '../types'

const withAuth = (cocap: string) => ({
  headers: {
    cocap
  }
})

const bootstrapTimeTracker = async (cocap: string) => {
  const { data } = await trackerClient.post<TrackerBootstrapResponse>(
    '/time-tracker/bootstrap',
    { clientApp: 'cocap-front' as const, clientTimestamp: new Date().toISOString() },
    withAuth(cocap)
  )
  return data
}

const startTimeTracker = async (cocap: string, location?: TrackerStartLocationPayload) => {
  const payload: TrackerActionPayload = {
    clientApp: 'cocap-front',
    clientTimestamp: new Date().toISOString(),
    location
  }
  const { data } = await trackerClient.post<TrackerSession>('/time-tracker/start', payload, withAuth(cocap))
  return data
}

const pauseTimeTracker = async (cocap: string, pauseType: 'break' | 'almuerzo') => {
  const payload: TrackerActionPayload = {
    clientApp: 'cocap-front',
    clientTimestamp: new Date().toISOString(),
    pauseType
  }
  const { data } = await trackerClient.post<TrackerSession>('/time-tracker/pause', payload, withAuth(cocap))
  return data
}

const resumeTimeTracker = async (cocap: string) => {
  const payload: TrackerActionPayload = {
    clientApp: 'cocap-front',
    clientTimestamp: new Date().toISOString()
  }
  const { data } = await trackerClient.post<TrackerSession>('/time-tracker/resume', payload, withAuth(cocap))
  return data
}

const stopTimeTracker = async (cocap: string) => {
  const payload: TrackerActionPayload = {
    clientApp: 'cocap-front',
    clientTimestamp: new Date().toISOString()
  }
  const { data } = await trackerClient.post<TrackerSession>('/time-tracker/stop', payload, withAuth(cocap))
  return data
}

const logoutStopTimeTracker = async (cocap: string) => {
  const payload: TrackerActionPayload = {
    clientApp: 'cocap-front',
    clientTimestamp: new Date().toISOString()
  }
  const { data } = await trackerClient.post<TrackerSession>('/time-tracker/logout-stop', payload, withAuth(cocap))
  return data
}

export {
  bootstrapTimeTracker,
  logoutStopTimeTracker,
  pauseTimeTracker,
  resumeTimeTracker,
  startTimeTracker,
  stopTimeTracker
}
